module.exports = __webpack_public_path__ + "assets/img/focus.b8933e3d.webp";